import { render, staticRenderFns } from "./PurchasedItemReceiveSummary.vue?vue&type=template&id=2402ae14&scoped=true"
import script from "./PurchasedItemReceiveSummary.vue?vue&type=script&lang=js"
export * from "./PurchasedItemReceiveSummary.vue?vue&type=script&lang=js"
import style0 from "./PurchasedItemReceiveSummary.vue?vue&type=style&index=0&id=2402ae14&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2402ae14",
  null
  
)

export default component.exports